import React from 'react';

export default function GridContainer({ className, children }) {
  return (
  <div className={`grid-container maw1200 pl24 pr24 ml-auto mr-auto ${ className || ''}`}>
    { children }
  </div>
  )
}
